export const getStyles = (
	props: any,
	align = 'left',
	maxWidth: number | string
) => [
		props,
		{
			className: `TableAlign-${align}`
		},
	];
